module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "snackbar"
  }, [_c('transition-group', {
    attrs: {
      "name": "slide",
      "appear": "appear",
      "mode": "out-in"
    }
  }, _vm._l((_vm.messages), function(item, i) {
    return _c('div', {
      key: ('item-' + i),
      staticClass: "message-container",
      class: 'type-' + item.type
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item.message)
      }
    }), _c('md-button', {
      class: {
        'md-icon-button md-dense': true, 'md-accent': (item.type != 'error'), 'md-primary': (item.type == 'error')
      },
      on: {
        "click": function($event) {
          _vm.removeMessageImmediately(i)
        }
      }
    }, [_c('md-icon', [_vm._v("clear")])], 1)], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bcb9da72","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Snackbar.vue
// module id = 1248
// module chunks = 0